/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/role-supports-aria-props */
import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/users/usersActions";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../../_metronic/_partials/controls";
import { CreateUserForm } from "./CreateUserForm";
import { EditUserForm } from "./EditUserForm";
import { useSubheader } from "../../../../../../_metronic/layout";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";

const initUser = {
  id: undefined,
  name: "",
  email: "",
};

export function UserEdit() {
  const navigate = useNavigate();
  const { id } = useParams();
  // Subheader
  const suhbeader = useSubheader();

  // Tabs
  const [tab, setTab] = useState("basic");
  const [title, setTitle] = useState("");
  const dispatch = useDispatch();
  // const layoutDispatch = useContext(LayoutContext.Dispatch);
  const { actionsLoading, userForEdit } = useSelector(
    (state) => ({
      actionsLoading: state.users.actionsLoading,
      userForEdit: state.users.userForEdit,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.fetchUser(id));
  }, [id, dispatch]);

  useEffect(() => {
    let _title = id ? "" : "New User";
    if (userForEdit && id) 
	{
		_title = `Edit User '${userForEdit.name}'`;
    
	}

    setTitle(_title);
    suhbeader.setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userForEdit, id]);

  const saveUser = (values) => {
    if (!id) {
      dispatch(actions.createUser(values)).then(() => backToUsersList());
    } else {
      dispatch(actions.updateUser(values)).then(() => backToUsersList());
    }
  };

  const btnRef = useRef();  
  const saveUserClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  const backToUsersList = () => {
    navigate("/user");
  };

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title}>
        <CardHeaderToolbar>
          <button
            type="button"
            onClick={backToUsersList}
            className="btn btn-light"
          >
            <i className="fa fa-arrow-left"></i>
            Back
          </button>
          {`  `}
          <button
            id="form-submit-user"
            type="submit"
            className="btn btn-primary ml-2"
            onClick={saveUserClick}
          >
            Save
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <ul className="nav nav-tabs nav-tabs-line " role="tablist">
          <li className="nav-item" onClick={() => setTab("basic")}>
            <a
              className={`nav-link ${tab === "basic" && "active"}`}
              data-toggle="tab"
              role="tab"
              aria-selected={(tab === "basic").toString()}
            >
              Basic info
            </a>
          </li>
          {id && (
            <li className="nav-item" onClick={() => setTab("businesses")}>
              <a
                className={`nav-link ${tab === "businesses" && "active"}`}
                data-toggle="tab"
                role="tab"
                aria-selected={(tab === "businesses").toString()}
              >
                User Businesses ({userForEdit?.businesses?.length || 0})
              </a>
            </li>
          )}
        </ul>
        <div className="mt-5">
          {tab === "basic" && id && (
            <EditUserForm
              actionsLoading={actionsLoading}
              user={userForEdit || initUser}
              btnRef={btnRef}
              saveUser={saveUser}
            />
          )}
		  
		  {tab === "basic" && !id && (
            <CreateUserForm
              actionsLoading={actionsLoading}
              user={userForEdit || initUser}
              btnRef={btnRef}
              saveUser={saveUser}
            />
          )}

          {tab === "businesses" && id && (
            <div className="card card-custom gutter-b shadow-none">
              <div className="card-body p-0">
                {userForEdit?.businesses && userForEdit.businesses.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table table-head-custom table-vertical-center table-head-bg">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Business Name</th>
                          <th>Email</th>
                          <th>Status</th>
                          <th>Approved By</th>
                          <th>Premium Status</th>
                          <th>Created At</th>
                          <th className="text-right">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {userForEdit.businesses.map((biz) => (
                          <tr key={biz.id}>
                            <td className="font-weight-bold">{biz.id}</td>
                            <td>
                              <div className="d-flex align-items-center">
                                <span className="font-weight-bold text-dark font-size-lg mr-2">
                                  {biz.name}
                                </span>
                                {biz.is_purchased && (
                                  <span
                                    className="badge font-weight-bolder"
                                    style={{
                                      backgroundColor: "#fff4de",
                                      color: "#b45309",
                                      border: "1px solid #fcd34d",
                                      padding: "3px 8px",
                                      fontSize: "11px",
                                      display: "inline-flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <i className="fa fa-crown mr-1" style={{ color: "#d97706", fontSize: "11px" }}></i>
                                    Premium
                                  </span>
                                )}
                              </div>
                            </td>
                            <td>{biz.business_email || "-"}</td>
                            <td>
                              <span
                                className={`badge badge-inline font-weight-bold ${
                                  biz.status === "approved"
                                    ? "badge-light-success text-success"
                                    : biz.status === "pending"
                                    ? "badge-light-warning text-warning"
                                    : biz.status === "rejected"
                                    ? "badge-light-danger text-danger"
                                    : "badge-light-secondary"
                                }`}
                              >
                                {biz.status}
                              </span>
                            </td>
                            <td>
                              {biz.approved_by_name ? (
                                <span className="font-weight-bold text-dark">{biz.approved_by_name}</span>
                              ) : (
                                <span className="text-muted">-</span>
                              )}
                            </td>
                            <td>
                              {biz.is_purchased ? (
                                <span className="text-warning font-weight-bold">
                                  <i className="fa fa-check-circle text-warning mr-1"></i>
                                  Premium Business
                                </span>
                              ) : (
                                <span className="text-muted">Standard / Free</span>
                              )}
                            </td>
                            <td>
                              {biz.createdAt
                                ? new Date(biz.createdAt).toLocaleDateString()
                                : "-"}
                            </td>
                            <td className="text-right">
                              <button
                                type="button"
                                className="btn btn-sm btn-light-primary font-weight-bold"
                                onClick={() => navigate(`/business/${biz.id}/edit`)}
                              >
                                <i className="fa fa-edit mr-1"></i> Edit Business
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="text-center py-10 bg-light rounded">
                    <i className="fa fa-store text-muted font-size-h1 mb-3 d-block"></i>
                    <h5 className="text-muted font-weight-bold">No businesses listed for this user.</h5>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </CardBody>
    </Card>
  );
}
/*** 

{id && (
            <>
              {" "}
              <li className="nav-item" onClick={() => setTab("remarks")}>
                <a
                  className={`nav-link ${tab === "remarks" && "active"}`}
                  data-toggle="tab"
                  role="button"
                  aria-selected={(tab === "remarks").toString()}
                >
                  User remarks
                </a>
              </li>
              <li className="nav-item" onClick={() => setTab("specs")}>
                <a
                  className={`nav-link ${tab === "specs" && "active"}`}
                  data-toggle="tab"
                  role="tab"
                  aria-selected={(tab === "specs").toString()}
                >
                  User specifications
                </a>
              </li>
            </>
          )}
		  
**********************************************************

{tab === "remarks" && id && (
            <RemarksUIProvider currentUserId={id}>
              <Remarks />
            </RemarksUIProvider>
          )}
          {tab === "specs" && id && (
            <SpecificationsUIProvider currentUserId={id}>
              <Specifications />
            </SpecificationsUIProvider>
          )}

 ***/